import React from 'react';
import { ShelfEmptySpot } from 'dig-illustrations/dist/cjs/spot/shelf-empty';
import styles from './select-template-modal.scss';
import HelloModal from 'common/components/hello-modal';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import Button, { ButtonType } from 'hellospa/foundation/control/button';
import Heading, { HeadingType } from 'hellospa/foundation/typography/heading';
import Body from 'hellospa/foundation/typography/body';
import { Props } from './select-template-modal';
import { redirectTo } from 'hellospa/common/utils/redirect';

export function ModalZeroState({
  isOpen, onRequestClose, userCanCreateTemplates,
}: Pick<Props, 'isOpen' | 'onRequestClose' | 'userCanCreateTemplates'>) {
  let buttons: undefined | Array<JSX.Element> = [];
  buttons.push(
    <Button
      key="close"
      kind={ButtonType.Subtle}
      onClick={onRequestClose}
    >
      <FormattedMessage
        id=""
        description="Close button on a modal"
        defaultMessage="Close" />
    </Button>,
  );
  buttons.push(
    <Button key="create" onClick={() => { redirectTo('/prep-and-send/new/4'); }}>
      <FormattedMessage
        id=""
        description="Modal button, links to create a template"
        defaultMessage="Create a template" />
    </Button>,
  );
  let content = (
    <FormattedMessage
      id=""
      description="text block when there are no templates in the account"
      defaultMessage="Templates are great for standard documents like NDAs and employee contracts. Create a template once, then send it out as often as you need." />
  );
  let width = '540px';

  if (!userCanCreateTemplates) {
    width = '720px';
    buttons = undefined;
    content = (
      <div>
        <Heading kind={HeadingType.H2}>
          <FormattedMessage
            id="Modal text"
            description="Modal text"
            defaultMessage="When an admin shares a template with you, find it here." />
        </Heading>

        <Body>
          <FormattedMessage
            id=""
            description="Modal text"
            defaultMessage="Templates save you time on docs that need signing on a regular basis" />
        </Body>

        <ShelfEmptySpot />
      </div>
    );
  }

  return (
    <HelloModal
      buttons={buttons}
      contentLabel={<FormattedMessage
        id=""
        description="title for template picker modal when there are no templates"
        defaultMessage="No templates yet" />}
      width={width}
      scrollable={false}
      extraBodyClasses={classNames(styles.body, {
        [styles.canCreate]: userCanCreateTemplates,
      })}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      extraClasses={styles.templatePickerModal}
      contentClasses={styles.templatePickerModal}
    >
      <div className={styles.templatePickerContainer}>
        <span className={styles.noTemplates}>
          {content}
        </span>
      </div>
    </HelloModal>
  );

}
